import { render, staticRenderFns } from "./SelectMailingChannel.vue?vue&type=template&id=7ea0a755&scoped=true&"
import script from "./SelectMailingChannel.vue?vue&type=script&lang=js&"
export * from "./SelectMailingChannel.vue?vue&type=script&lang=js&"
import style0 from "./SelectMailingChannel.vue?vue&type=style&index=0&id=7ea0a755&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ea0a755",
  null
  
)

export default component.exports